var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstrela(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_97)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5564 12.706C17.108 13.139 16.9043 13.763 17.0093 14.375L17.6866 18.291C17.8976 19.51 16.9211 20.5 15.8134 20.5C15.5215 20.5 15.2201 20.431 14.9282 20.279L11.3845 18.43C11.1073 18.286 10.8038 18.214 10.4993 18.214C10.1959 18.214 9.89243 18.286 9.61523 18.43L6.07147 20.279C5.77957 20.431 5.47822 20.5 5.18632 20.5C4.07857 20.5 3.10207 19.51 3.31312 18.291L3.99037 14.375C4.09537 13.763 3.89167 13.139 3.44332 12.706L0.575768 9.933C-0.551933 8.842 0.0707209 6.941 1.62892 6.716L5.59162 6.145C6.21112 6.056 6.74662 5.67001 7.02277 5.11301L8.79517 1.55099C9.14377 0.849995 9.82207 0.5 10.4993 0.5C11.1776 0.5 11.8559 0.849995 12.2045 1.55099L13.9769 5.11301C14.2531 5.67001 14.7886 6.056 15.4081 6.145L19.3708 6.716C20.929 6.941 21.5516 8.842 20.4239 9.933L17.5564 12.706Z",
    fill: "#FFB930"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrela);
export default __webpack_public_path__ + "static/media/estrela.b635ed5e8bc0b2c1ba18f2d398134417.svg";
export { ForwardRef as ReactComponent };